import { Dialog } from '@st/theme'

import { Modal } from '@st/theme'

import { Folder, STChecklistItem } from '@st/sdk'
import { Button, DialogButtons, RadialProgressBar } from '@st/theme'
import { useState } from 'react'
import { match } from 'ts-pattern'
import { ClientCard, DocumentChecklistItem } from './ui'

export function ClientQuestionnaireCard({
  step,
  folder,
  nonDocumentChecklistItems,
  onClickEnterQuestionnaire,
  isLocked
}: {
  step?: string
  folder: Folder
  nonDocumentChecklistItems: STChecklistItem[]
  onClickEnterQuestionnaire: () => void
  isLocked?: boolean
}) {
  const [dialog, setDialog] = useState<'locked' | undefined>(undefined)

  return (
    <ClientCard step={step} title="Complete questionnaire">
      <div className="space-y-4">
        <div className="flex flex-row items-center justify-between">
          <div className="space-y-1">
            <h2 className="text-xl font-medium text-gray-800">{folder.year} Tax questionnaire</h2>
            <p className="text-base text-gray-700">
              {match(nonDocumentChecklistItems)
                .with([], () => {
                  return <>The questionnaire will cover anything that came up in {folder.year}.</>
                })
                .otherwise(() => {
                  return (
                    <>
                      The questionnaire will go over the items below and anything new which came up
                      in {folder.year}.
                    </>
                  )
                })}
            </p>
          </div>
          <RadialProgressBar percentage={folder.clientOrganizer.questionnaireProgress} size={60} />
        </div>

        {nonDocumentChecklistItems.length > 0 && (
          <ul className="-mx-6 border-t border-gray-200">
            {nonDocumentChecklistItems.map((item) => {
              return (
                <DocumentChecklistItem
                  key={item.id}
                  title={item.name}
                  description={item.note ?? ''}
                />
              )
            })}
          </ul>
        )}

        {match(dialog)
          .with('locked', () => {
            return (
              <Modal isOpen={true}>
                <Dialog
                  title="Questionnaire locked"
                  subtitle="A questionnaire cannot be edited once it has been submitted, but you can upload additional documents above at any time. Please contact us if you have any questions."
                  buttons={
                    <DialogButtons>
                      <Button variant="primary" onClick={() => setDialog(undefined)}>
                        OK
                      </Button>
                    </DialogButtons>
                  }
                />
              </Modal>
            )
          })
          .otherwise(() => null)}

        <div className="flex flex-row justify-end">
          <Button
            variant="primary"
            className={isLocked ? 'opacity-80' : ''}
            onClick={() => {
              if (isLocked) {
                setDialog('locked')
              } else {
                onClickEnterQuestionnaire()
              }
            }}
          >
            Enter Questionnaire
          </Button>
        </div>
      </div>
    </ClientCard>
  )

  function formatChecklistItem(item: STChecklistItem) {
    return item.name + (item.note ? ` (${item.note})` : '')
  }
}
